export function radialIndex(x, y, length) {
  if (!length || Math.hypot(x, y) < 0.25) return -1
  const angle = (Math.atan2(y, x) + Math.PI / 2 + Math.PI * 2) % (Math.PI * 2)
  return Math.round(angle / (Math.PI * 2 / length)) % length
}

